import { inset, pxToRem, responsiveFontSize, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import {
  RADIO_BUTTON__LABEL_CLASS,
  RADIO_BUTTON__LABEL_TEXT_CLASS,
} from 'src/components/atoms/RadioButton';

const { spacing, text, colors, fonts } = theme;

export const popoverButtonText = css`
  ${responsiveFontSize(text.sm)};
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
`;

export const popoverButtonOptionValue = css`
  color: ${colors.greySlate};
  margin-left: 0.3rem;
`;

export const popoverContent = css`
  padding: 1rem;

  .${RADIO_BUTTON__LABEL_CLASS} {
    flex-direction: row-reverse;
    text-align: right;

    .${RADIO_BUTTON__LABEL_TEXT_CLASS} {
      margin-right: ${pxToRem(spacing.sm)};
    }
  }
`;

export const modalContent = css`
  padding: ${inset(spacing.md, spacing.xxl)};
`;
